import React from "react"
import PropTypes from "prop-types"

import CircularProgress from "@material-ui/core/CircularProgress"

import { ErrorContainer, LoadingContainer, Text } from "./styles"

import sad from "../../assets/sad.png"

const Loading = props => {
	const { loading, error, children } = props 

	if (loading) {
		return (
			<LoadingContainer>
				<CircularProgress />
			</LoadingContainer>
		)
	} else if (error) {
		return (
			<ErrorContainer>
				<img src={sad} alt="sad-icon" />
				<Text>{error}</Text>
			</ErrorContainer>
		)
	} else {
		return children
	}
}

Loading.defaultProps = {
	error: null
}

Loading.propTypes = {
	loading: PropTypes.bool.isRequired,
	error: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf([PropTypes.node])]).isRequired
}

export default Loading